// extracted by mini-css-extract-plugin
module.exports = {"MuiFormControlRoot":"CouponsFormSelect_MuiFormControlRoot__3Hv-D"};